export default __webpack_public_path__ + "static/media/ai.dd9b206e.png";